'use client'
import HgToggle from '~/design-system/hg/components/HgToggle'
import {type HgPricingCardsHeadingProps} from './types'
import {usePathname, useRouter, useSearchParams} from 'next/navigation'

export default function HgPricingCardsHeading({
  headingEyebrow,
  headingToggleLabel,
}: HgPricingCardsHeadingProps) {
  const searchParams = useSearchParams()
  const router = useRouter()
  const pathname = usePathname()
  const checked = searchParams.get('pricing') !== 'monthly'
  return (
    <div className="flex items-center justify-between px-s5 py-s3 text-text-subdued">
      {headingEyebrow && (
        <div className="hidden arcadia-ui-4 md:block">{headingEyebrow}</div>
      )}
      <HgToggle
        label={headingToggleLabel}
        checked={checked}
        onCheckedChange={checked => {
          const params = new URLSearchParams(searchParams.toString())
          params.set('pricing', checked ? 'annual' : 'monthly')
          router.push(`${pathname}?${params.toString()}`, {scroll: false})
        }}
      />
    </div>
  )
}
